// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__T3mB5","rootSmall":"AddTileButton_rootSmall__3Y4uC"};